import {
  useDeleteCloudEnvironmentsMutation,
  useGetCloudEnvironmentsQuery,
} from "~/services/cloudenvironment";
import { SIMPLCloudEntity } from "../cloudtable/SimplCloudEntity";
import { CloudEnviromentHeader } from "~/models/cloudenvironment/CloudEnviromentHeader";
import { DetailViewCloudEnvironment } from "./DetailsViewCloudEnvironment";
import { useState } from "react";

export const SIMPLCloudEnvironment = () => {
  const [isActive, setIsActive] = useState(true);
  return (
<SIMPLCloudEntity
  title="Cloud Environment Management"
  addLabel="Add Cloud"
  tableHeaders={CloudEnviromentHeader}
  fetchHook={useGetCloudEnvironmentsQuery}
  deleteHook={useDeleteCloudEnvironmentsMutation}
  navigateAddRoute="/cloud-environment/add"
  navigateEditRoute="/cloud-environment/update"
  detailViewComponent={DetailViewCloudEnvironment}
   showButtonDecommissionInModal={false}
  showButtonDownloadInModal={false}
  showConfigFileInModal={false}
   showButtonDeleteInModal
  showButtonDetailsInModal
  showEditInModal
  isActive={isActive}
  setIsActive={setIsActive}
  tabs
/>
  );
};
